import React from 'react';
import { Routes, Route } from "react-router-dom";
import {
  Auth, Users, Blog, Courses, Menu, Newsletter, Inyde, Ope, Opes, Opess, GestionComercial, Asesor, Omicronshoppagos, Presentacion, Princ,
  Transaccionescredito, Clientescreditos, Facturapagas, Cambiobase, Soporte, Inydes, Inydess, GestionComercials, GestionComercialss, MarkCatPromos,
  Markpromos, Altacliente, Altaclientecome,
  Markfacturas
} from "../pages/admin";

// Bioequal
import { AsesorBioequal, InydeBioequal, OpeBioequal } from "../pages/admin/Bioequal";

// Bioelite
import { AsesorBioelite, InydeBioelite, OpeBioelite } from "../pages/admin/Bioelite";

// Omigenomics
import { AsesorReve, InydeReve, OpeReve } from "../pages/admin/Omigenomics_Reve"; //Reve

import { AsesorDZ, InydeDZ, OpeDZ } from "../pages/admin/Omigenomics_DZ"; //Reve


import { AdminLayout } from "../layouts";
import { useAuth } from "../hooks";
import { Perfil } from '../pages/admin/Perfil';

import { TicketMarketing } from "../pages/admin/Asesor/Soporte/TicketMarketing"
import { TicketMaterial } from "../pages/admin/Asesor/Soporte/TicketMaterial"

export function AdminRouter() {
  const { user } = useAuth();
  const loadLayout = (Layout, Page) => {
    return (
      <Layout>
        <Page />
      </Layout>
    )
  }
  return (
    <Routes>
      {!user ? (
        <Route path='/' element={<Auth />} />//login
      ) : (
        <>
          {["/admin", "/admin/Princ"].map((path) => (
            <Route
              key={path}
              path={path}
              element={loadLayout(AdminLayout, Princ)}// Donde esta "Courses" cambia la pagina de inicio
            />
          ))}
          <Route path='/' element={<Auth />} />
          <Route path="/admin/users" element={loadLayout(AdminLayout, Users)} />
          <Route path="/admin/courses" element={loadLayout(AdminLayout, Courses)} />
          <Route path="/admin/menu" element={loadLayout(AdminLayout, Menu)} />
          <Route path="/admin/newsletter" element={loadLayout(AdminLayout, Newsletter)} />
          <Route path="/admin/blog" element={loadLayout(AdminLayout, Blog)} />
          <Route path="/admin/inyde" element={loadLayout(AdminLayout, Inyde)} />
          <Route path="/admin/inydes" element={loadLayout(AdminLayout, Inydes)} />
          <Route path="/admin/inydess" element={loadLayout(AdminLayout, Inydess)} />
          <Route path="/admin/ope" element={loadLayout(AdminLayout, Ope)} />
          <Route path="/admin/opes" element={loadLayout(AdminLayout, Opes)} />
          <Route path="/admin/opess" element={loadLayout(AdminLayout, Opess)} />
          <Route path="/admin/gestioncomercial" element={loadLayout(AdminLayout, GestionComercial)} />
          <Route path="/admin/gestioncomercials" element={loadLayout(AdminLayout, GestionComercials)} />
          <Route path="/admin/gestioncomercialss" element={loadLayout(AdminLayout, GestionComercialss)} />
          <Route path="/admin/asesor" element={loadLayout(AdminLayout, Asesor)} />
          <Route path="/admin/presentacion" element={loadLayout(AdminLayout, Presentacion)} />
          <Route path="/admin/omicronshoppagos" element={loadLayout(AdminLayout, Omicronshoppagos)} />
          <Route path="/admin/princ" element={loadLayout(AdminLayout, Princ)} />
          <Route path="/admin/transaccionescredito" element={loadLayout(AdminLayout, Transaccionescredito)} />
          <Route path="/admin/clientescreditos" element={loadLayout(AdminLayout, Clientescreditos)} />
          <Route path="/admin/facturapagas" element={loadLayout(AdminLayout, Facturapagas)} />
          <Route path="/admin/cambiobase" element={loadLayout(AdminLayout, Cambiobase)} />
          <Route path="/admin/soporte" element={loadLayout(AdminLayout, Soporte)} />
          <Route path="/admin/markcatpromos" element={loadLayout(AdminLayout, MarkCatPromos)} />
          <Route path="/admin/markpromos" element={loadLayout(AdminLayout, Markpromos)} />
          <Route path="/admin/markfacturas" element={loadLayout(AdminLayout, Markfacturas)} />
          <Route path="/admin/perfil" element={loadLayout(AdminLayout, Perfil)} />
          <Route path="/admin/altaclientes" element={loadLayout(AdminLayout, Altacliente)} />
          <Route path="/admin/altaclientescome" element={loadLayout(AdminLayout, Altaclientecome)} />


          <Route path="/admin/bioequal/asesor" element={loadLayout(AdminLayout, AsesorBioequal)} />
          <Route path="/admin/bioequal/inyde" element={loadLayout(AdminLayout, InydeBioequal)} />
          <Route path="/admin/bioequal/ope" element={loadLayout(AdminLayout, OpeBioequal)} />

          <Route path="/admin/bioelite/asesor" element={loadLayout(AdminLayout, AsesorBioelite)} />
          <Route path="/admin/bioelite/inyde" element={loadLayout(AdminLayout, InydeBioelite)} />
          <Route path="/admin/bioelite/ope" element={loadLayout(AdminLayout, OpeBioelite)} />

          <Route path="/admin/Reve/asesor" element={loadLayout(AdminLayout, AsesorReve)} />
          <Route path="/admin/Reve/inyde" element={loadLayout(AdminLayout, InydeReve)} />
          <Route path="/admin/Reve/ope" element={loadLayout(AdminLayout, OpeReve)} />

          <Route path="/admin/DZ/asesor" element={loadLayout(AdminLayout, AsesorDZ)} />
          <Route path="/admin/DZ/inyde" element={loadLayout(AdminLayout, InydeDZ)} />
          <Route path="/admin/DZ/ope" element={loadLayout(AdminLayout, OpeDZ)} />

          {/* Ticekt de marketing para asesores */}
          <Route path="/admin/asesor/marketing" element={loadLayout(AdminLayout, TicketMarketing)} />
          <Route path="/admin/asesor/marketing/eventos" element={loadLayout(AdminLayout, TicketMaterial)} />
        </>
      )
      }
    </Routes>
  )
}